import React from 'react'
import { canMoveInOnlyCols } from '../../utils/rules'
import { RowSettings } from './RowSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { useEditor } from '@craftjs/core'

export const defaultProps = {
  layout: 'cols',
}

export const dynamicProps = []

export const Row = withBlock(
  props => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }
    const { layout } = blockProps
    const { children } = props

    const _ = props.renderValue

    return (
      <div
        className={`block-row block-row--${layout} ${props.className}`}
        ref={ref => props.retRef(ref)}
      >
        {children?.props?.children}
      </div>
    )
  },
  defaultProps
)

Row.craft = withCraft({
  name: 'Row',
  defaultProps: defaultProps,
  settings: RowSettings,
  canMoveIn: canMoveInOnlyCols,
})
